
<div *ngIf="financialPosition" class="w-full flex flex-col items-center">
  <div class="flex flex-col gap-4 items-center w-full">
    <div class="w-full flex flex-col gap-y-3 items-end pt-8">
      <div class="relative inline-block text-left">
        <div>
          <button (click)="showActionDropdown = !showActionDropdown; $event.stopPropagation()" type="button" class="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50" id="menu-button" aria-expanded="true" aria-haspopup="true">
            Actions
            <svg class="-mr-1 h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
            </svg>
          </button>
        </div>
        <div *ngIf="showActionDropdown" (clickOutside)="showActionDropdown = false"  class="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
          <div class="py-1" role="none">
            <a (click)="showActionDropdown = false; onComment()" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer" role="menuitem" tabindex="-1" id="menu-item-0">Comment</a>
            <a (click)="showActionDropdown = false; onEdit()" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer" role="menuitem" tabindex="-1" id="menu-item-1">Edit</a>
            <a (click)="showActionDropdown = false; onDelete()" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer" role="menuitem" tabindex="-1" id="menu-item-2">Delete</a>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col gap-5 md:gap-10 items-center w-full mb-20">
      <div *ngIf="selectedMode === 'view'" class="w-full flex flex-row justify-center">
        <tandem-financial-position-graph class="w-3/4 h-auto" [financialPosition]="financialPosition" [showLegend]="false"></tandem-financial-position-graph>
      </div>
      <div *ngIf="selectedMode === 'proposeChanges'" class="w-full flex flex-col xl:flex-row gap-8 xl:items-center mt-4">
        <tandem-card *ngIf="selectedMode === 'proposeChanges'" class="w-full" [ngClass]="selectedMode === 'proposeChanges' && this.currentlyProposedChanges && this.currentlyProposedChanges.length > 0 ? 'xl:w-3/4' : 'xl:w-3/4'">
          <tandem-propose-changes [financialPosition]="financialPosition"></tandem-propose-changes>
        </tandem-card>
        <div class="flex flex-col xl:w-1/4" style="height: 435px">
          <tandem-card class="flex flex-col h-full" *ngIf="selectedMode === 'proposeChanges'" [useFullHeight]="true" [scrollable]="true">
            <div class="flex flex-col items-center">
              <h2 class="text-2xl text-center mb-6">Action Items</h2>
              <tandem-button *ngIf="currentlyProposedChanges.length > 0" class="w-fit" theme="outline" [type]="'submit'" [onClick]="syncGoals.bind(this)">Create Goals</tandem-button>
              <div *ngIf="this.currentlyProposedChanges" [formGroup]="actionItemsForm" class="w-full flex flex-col items-start mt-4">
                <div *ngFor="let itemControl of actionItems.controls; index as i" class="relative flex justify-between w-full">
                  <tandem-form-checkbox
                    [control]="getControl(itemControl)"
                    [controlName]="i.toString()"
                    [inputId]="this.currentlyProposedChanges[i].id!.toString()"
                    (checkboxToggled)="onToggle($event, this.currentlyProposedChanges[i])"
                    [label]="getMessage(this.currentlyProposedChanges[i])"
                    [ngClass]="{'line-through': this.currentlyProposedChanges[i].completed}"
                  >
                  </tandem-form-checkbox>
                  <div (click)="onDeleteProposedChange(i)" class="flex flex-col justify-start px-2 md:px-5">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                  </div>
                </div>
              </div>
              <div *ngIf="!this.currentlyProposedChanges || this.currentlyProposedChanges.length === 0">
                <h2 class="italic mb-4">No Action Items Created</h2>
              </div>
            </div>
          </tandem-card>
        </div>
      </div>

      <div *ngIf="selectedMode === 'view'" class="flex flex-col sm:flex-row w-full gap-8">
        <div class="w-1/2 flex flex-col items-center">
          <div class="max-sm:hidden flex flex-col gap-y-3">
            <h2 class="text-2xl font-bold">Assets</h2>
            <h5 class="text-lg">Total Assets: {{financialPosition.totalAssets | currency}}</h5>
            <h5 class="text-lg">Liquid Assets: {{financialPosition.liquidAssets | currency}}</h5>
            <h5 class="text-lg">Average Return: {{financialPosition.averageReturn | percent:'1.2-2'}}</h5>
          </div>
        </div>
        <div class="w-1/2 flex flex-col items-center">
          <div class="max-sm:hidden flex flex-col gap-y-3">
            <h2 class="text-2xl font-bold">Liabilities</h2>
            <h5 class="text-lg">Total Liabilities: {{financialPosition.totalLiabilities | currency}}</h5>
            <h5 class="text-lg">Short-Term Liabilities: {{financialPosition.shortTermLiabilities | currency}}</h5>
            <h5 class="text-lg">Minimum Monthly Payment: {{financialPosition.totalMinimumPayment | currency}}</h5>
            <h5 class="text-lg">Average Interest Rate: {{financialPosition.averageInterestRate | percent:'1.2-2'}}</h5>
          </div>

        </div>
      </div>
      <div class="w-full flex flex-row gap-10">
        <tandem-button class="w-1/2" [color]="selectedMode === 'view' ? 'primary' : 'white'" [onClick]="setMode.bind(this, 'view')">View</tandem-button>
        <tandem-button class="w-1/2" [color]="selectedMode === 'view' ? 'white' : 'primary'" [onClick]="setMode.bind(this, 'proposeChanges')">Propose Changes</tandem-button>
      </div>
      <div class="flex flex-col sm:flex-row w-full gap-8">
        <div class="w-full sm:w-1/2 flex flex-col">
          <div class="sm:hidden flex flex-col">
            <h2 class="text-2xl font-bold">Assets</h2>
            <h5 class="text-lg">Total Assets: {{financialPosition.totalAssets | currency}}</h5>
            <h5 class="text-lg">Liquid Assets: {{financialPosition.liquidAssets | currency}}</h5>
            <h5 class="text-lg">Average Return: {{financialPosition.averageReturn | percent:'1.2-2'}}</h5>
          </div>
          <tandem-asset-table *ngFor="let assetCategory of financialPosition.assets" [assetCategory]="assetCategory" [mode]="selectedMode === 'view' ? 'view' : 'proposeChanges'" (changesMade)="handleUpdate()" (onComment)="handleAssetComment($event)" [details]="financialPosition.assetDetails"></tandem-asset-table>
        </div>
        <div class="w-full sm:w-1/2 flex flex-col">
          <div class="sm:hidden flex flex-col">
            <h2 class="text-2xl font-bold">Liabilities</h2>
            <h5 class="text-lg">Total Liabilities: {{financialPosition.totalLiabilities | currency}}</h5>
            <h5 class="text-lg">Short-Term Liabilities: {{financialPosition.shortTermLiabilities | currency}}</h5>
            <h5 class="text-lg">Minimum Monthly Payment: {{financialPosition.totalMinimumPayment | currency}}</h5>
            <h5 class="text-lg">Average Interest Rate: {{financialPosition.averageInterestRate | percent:'1.2-2'}}</h5>
          </div>
          <tandem-liability-table *ngFor="let liabilityCategory of financialPosition.liabilities"  [liabilityCategory]="liabilityCategory" [mode]="selectedMode === 'view' ? 'view' : 'proposeChanges'" (changesMade)="handleUpdate()" (onComment)="handleLiabilityComment($event)" [details]="financialPosition.liabilityDetails"></tandem-liability-table>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #buttons>
  <div class="flex flex-col gap-y-3 items-end">
    <div class="flex flex-row gap-4 max-sm:hidden">
      <tandem-button color="primary" [onClick]="onComment.bind(this)" class="whitespace-nowrap">Comment on {{getTrackingToolName('single')}}</tandem-button>
      <tandem-button color="white" [onClick]="onEdit.bind(this)">Edit</tandem-button>
      <tandem-button color="red" [onClick]="onDelete.bind(this)">Delete</tandem-button>
    </div>
  </div>
</ng-template>
